import requestMaker from 'lib';

export const registerUserDevice = deviceInfo => {
  const url = '/proxy/prv/cm/rud';
  const params = {};
  const payload = { ...deviceInfo };
  return requestMaker(url, { params, payload });
};
